export const SERIES_Z_BASE = 2;
// Matches the ECharts markLine default; pinned explicitly so persisted config
// can't sink reference lines below the series band.
export const REFERENCE_LINE_Z = 5;
// Paint order from series-list position: earlier in the list paints behind.
// Overrides any persisted per-series z — list position is the source of truth.
export const assignSeriesZByOrder = (series) => series.map((serie, index) => ({
    ...serie,
    z: SERIES_Z_BASE + index / series.length,
    ...(serie.markLine
        ? { markLine: { ...serie.markLine, z: REFERENCE_LINE_Z } }
        : {}),
}));
//# sourceMappingURL=seriesZOrder.js.map